import React from 'react';
import PropTypes from 'prop-types';

const GotoCartButton = ({ onButtonClick, price }) => {
  return (
    <div className="goto-cart">
      <span className="goto-cart_price">₹{price}</span>
      <button
        type="button"
        onClick={onButtonClick}
        className="goto-cart_button"
      >
        <span className="goto-cart_button-text">add to cart</span>
        <div
          className="goto-cart_icon"
          style={{
            maskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/cart.svg'})`,
            WebkitMaskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/cart.svg'})`
          }}
        />
        <div
          className="goto-cart_icon"
          style={{
            maskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/arrow-right.svg'})`,
            WebkitMaskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/arrow-right.svg'})`
          }}
        />
      </button>
    </div>
  );
};

GotoCartButton.propTypes = {
  price: PropTypes.string,
  onButtonClick: PropTypes.func
};

export default GotoCartButton;
